import { render } from "./LecturerIntroduction.vue?vue&type=template&id=3365b72e"
import script from "./LecturerIntroduction.vue?vue&type=script&lang=js"
export * from "./LecturerIntroduction.vue?vue&type=script&lang=js"

import "./LecturerIntroduction.vue?vue&type=style&index=0&id=3365b72e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__